import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from "tailwind-merge";
import Engage from "./game-style-icons/Engage";
import Pick from "./game-style-icons/Pick";
import Protect from "./game-style-icons/Protect";
import Siege from "./game-style-icons/Siege";
import Split from "./game-style-icons/Split";
function ChampionGameStyle(_a) {
    var gameStyle = _a.gameStyle, size = _a.size, _b = _a.color, color = _b === void 0 ? "primary" : _b, className = _a.className, iconClassName = _a.iconClassName;
    function iconSize() {
        switch (size) {
            case "small":
                return "w-4 h-4";
            case "xmedium":
                return "w-5 h-5";
            case "medium":
                return "w-6 h-6";
            case "mediumLarge":
                return "w-7 h-7";
            case "large":
                return "w-8 h-8";
            case "xlarge":
                return "w-10 h-10";
            case "2xlarge":
                return "w-12 h-12";
            case "3xlarge":
                return "w-14 h-14";
            case "4xlarge":
                return "w-16 h-16";
        }
    }
    function getColor() {
        switch (color) {
            case "red":
                return "fill-red-side";
            case "blue":
                return "fill-blue-side";
            case "primary":
                return "fill-primary";
            case "neutral":
                return "fill-neutral-500";
            case "white":
                return "fill-neutral-0";
            case "black":
                return "fill-[#141414]";
            case "neutral-300":
                return "fill-neutral-300";
        }
    }
    function getGameStyleIcon() {
        switch (gameStyle) {
            case "Protect":
                return (_jsx(Protect, { iconClassName: twMerge("", getColor(), iconClassName), className: twMerge("", iconSize(), className) }));
            case "Split":
                return (_jsx(Split, { iconClassName: twMerge("", getColor(), iconClassName), className: twMerge("", iconSize(), className) }));
            case "Siege":
                return (_jsx(Siege, { iconClassName: twMerge("", getColor(), iconClassName), className: twMerge("", iconSize(), className) }));
            case "Engage":
                return (_jsx(Engage, { iconClassName: twMerge("", getColor(), iconClassName), className: twMerge("", iconSize(), className) }));
            case "Pick":
                return (_jsx(Pick, { iconClassName: twMerge("", getColor(), iconClassName), className: twMerge("", iconSize(), className) }));
            default:
                return null;
        }
    }
    return getGameStyleIcon();
}
export default ChampionGameStyle;
